import React from 'react';
import PropTypes from 'prop-types';

const CountCard = ({ text, count }) => (
  <div className="count-card">
    <div className="count-card-text">{text}</div>
    <div className="count-card-subtitle">Count</div>
    <div className="count-card-count">{count}</div>
  </div>
);

CountCard.propTypes = {
  text: PropTypes.string.isRequired,
  count: PropTypes.number.isRequired,
};

export default CountCard;
